var domain = 'admin.bodyfittraining.com'
switch (window.location.host.split('.')[0]) {
    default:
        domain = 'https://admin.bodyfittraining.com'
        break
    case 'staging-challenge':
    case 'staging-admin':
        domain = 'https://staging-admin.bodyfittraining.com'
        break
    case 'localhost:8100':
    case 'bft':
        domain = 'https://bft.localhost'
        //domain = 'https://staging-admin.bodyfittraining.com'
        break
}

const state = {
    apiUrl: domain,
    imageUrl: domain,
    multiply: 1,
    isAdmin: ['bft.localhost', 'admin.bodyfittraining.com', 'staging-admin.bodyfittraining.com'].indexOf(window.location.hostname) >= 0 // admin portal not the app
}

const mutations = {
    UPDATE_MULTIPLY (state, value) {
        state.multiply = value
    }
}

const actions = {
    updateMultiply({commit, dispatch}, value) {
        if(value > 6 || value < 1) return
        commit('UPDATE_MULTIPLY', parseInt(value))
        dispatch('ShoppingList/multiplyShoppingList', null, {root: true})
    }
}

const getters = {
    imageUrl: (state) => {
        return state.imageUrl
    },
    multiply: (state) => state.multiply,
    isAdmin: (state) => state.isAdmin
}

export default {
    mutations,
    actions,
    state,
    getters,
    namespaced: true
}
